module.exports = __webpack_public_path__ + "img/maze_circular_c.f00be65f.svg";